const baseFontSizePx = 14;

export const px2rem = (px: number, baseFontSize = baseFontSizePx): string => {
  const rem = Math.round((px / baseFontSize) * 100) / 100;
  return `${rem}rem`;
};
